import { makeStyles} from '@mui/styles';

const useStyles = makeStyles((theme) => ({

    DialogCustom: {
        '& .MuiDialog-paper': {
            width: '50%', maxHeight: "100%", maxWidth: "none",
            "@media screen and (max-width: 768px)": {
                width: "100%",
                minWidth: "auto",
                margin: 0
            },
        }
    },

    boxOfTableModal: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[24], // Используем массив теней из темы MUI
        padding: theme.spacing(2),

        "@media screen and (max-width: 768px)": {
            padding: 0,
        }

    },
    modalActions: {
        backgroundColor: 'white'
    }
}));

export default useStyles;
